import {useApiWrite} from '../../../../hooks/useApiWrite';
import {WorkExperienceRequestBody} from '../../../../lib/api/RequestBodies/features/applicant/profile/WorkExperienceRequestBody';
import {ApiResponseError} from '../../../../lib/api/v1/types';

interface Args {
  applicantId: string;
  onSuccess?: () => void;
  onError?: (error?: ApiResponseError) => void;
}

export const useApplicantWorkExperience = ({applicantId, onError, onSuccess}: Args) => {
  const {makeManualRequestWithParams, isLoading, error} = useApiWrite({onError, onSuccess});
  const endpoint = `/api/v1/applicants/${applicantId}/work_experiences`;

  const create = (body: WorkExperienceRequestBody) => {
    makeManualRequestWithParams({
      path: endpoint,
      method: 'post',
      body,
    });
  };

  const update = (resourceId: string, body: WorkExperienceRequestBody) => {
    makeManualRequestWithParams({
      path: `${endpoint}/${resourceId}`,
      method: 'patch',
      body,
    });
  };

  const deleteEntry = (resourceId: string) => {
    makeManualRequestWithParams({
      path: `${endpoint}/${resourceId}`,
      method: 'delete',
    });
  };

  return {
    create,
    update,
    delete: deleteEntry,
    isLoading,
    error,
  };
};
